export * from './parallelogram.model';
export { createParallelogram } from './parallelogram.creator';
